<template>
  <div class="pending-container">
    <div class="spinner-grow text-info" role="status">
      <span class="visually-hidden">{{ t('searching') }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: "MiniLoading",
  setup() {
    const { t } = useI18n();
    return { t };
  }
})
</script>

<style scoped lang="sass">
.pending-container
  display: flex
  align-items: center
  justify-content: center
</style>